import React from 'react';
import { Col, Row } from 'react-bootstrap';
import './changePassword.styles.scss';
import { useLocation } from 'react-router-dom';
import ChangePasswordForm from './change-password-form/change-password-form.component';
import ShoppingCartHeader from '../../../components/commons/shopping-cart-header/shopping-cart-header';

function ChangeProfilePassword() {
  const location = useLocation();

  return (
    <>
      <ShoppingCartHeader text={'Change Password'} className="ep-header" />
      <Row className="edit-profile-page trinity-container">
        <ChangePasswordForm
          userName={location &&
            location.state &&
            location.state.userInfo &&
            location.state.userInfo.Username} />
      </Row>
    </>
  );
}
export default ChangeProfilePassword;
